import { useEffect, useState } from "react";
import useGoToNavigation from "../../util/useGotoNavigation";
import { useTranslation } from "react-i18next";
import { useUser } from "../../util/userContext/UserContext";
import AuthorityChecker from "../../components/common/authorityGuard/AuthorityChecker";

export const Sidebar = () => {
    const savedOpenMenus = JSON.parse(sessionStorage.getItem("openMenus") || "{\"order\":true,\"customer\":true,\"support\":true,\"purchase\":true}");
    const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>(savedOpenMenus);

    const { user } = useUser();
    const { t } = useTranslation();

    const { goToNavigation } = useGoToNavigation();

    function getActiveClass(href: string) {
        return window.location.pathname.startsWith(href) ? "active" : "";
    }

    function getActiveMenuClass(menu: string) {
        return window.location.pathname.indexOf(menu) >= 0 ? "active" : "";
    }

    const toggleMenu = (menu: string) => {
        setOpenMenus((prev) => {
            const updated = {
                ...prev,
                [menu]: !prev[menu],
            };
            sessionStorage.setItem("openMenus", JSON.stringify(updated));
            return updated;
        });
    };

    useEffect(() => {
        setOpenMenus(savedOpenMenus);
    }, []);

    return <>
        {user && (user.inOutFlag === 0
            // 내부(inOutFlag === 0) =======================================
            ? <div className="nav-container">
                <div className="nav-top-box">
                    <a className="btn btn-link p-0 logo">
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/logo_private.png"}
                            alt="Logo"
                            onClick={() => goToNavigation('main/dashboard', "", false)}
                        />
                    </a>
                </div>
                <div className="nav-list">
                    <ul>
                        <li className={`${getActiveMenuClass("main")} ${openMenus["main"] ? "open" : ""}`}>
                            <a onClick={() => toggleMenu("main")}>
                                <div className="menu menu1">{t('menu-home')}</div>
                                <div className="btn_arrow"></div>
                            </a>
                            {openMenus["main"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                <ul>
                                    <li className={getActiveClass("/main/dashboard")}>
                                        <a onClick={() => goToNavigation("main/dashboard", "", false)}>
                                            {t('menu-second-dashboard')}
                                        </a>
                                    </li>
                                    <AuthorityChecker authorityNames={['salesReadYn']}>
                                        <li className={getActiveClass("/main/sales")}>
                                            <a onClick={() => goToNavigation("main/sales/list", "", false)}>
                                                {t('menu-second-sales')}
                                            </a>
                                        </li>
                                    </AuthorityChecker>
                                    <AuthorityChecker authorityNames={['overseasReadYn']}>
                                        <li className={getActiveClass("/main/overseas")}>
                                            <a onClick={() => goToNavigation("main/overseas/list", "", false)}>
                                                {t('menu-second-overseas_corporation')}
                                            </a>
                                        </li>
                                    </AuthorityChecker>
                                    <li className={getActiveClass("/main/exchange")}>
                                        <a onClick={() => goToNavigation("main/exchange", "", false)}>
                                            {t('menu-second-exchange')}
                                        </a>
                                    </li>
                                </ul>)}
                        </li>

                        <AuthorityChecker
                            authorityNames={['orderReadYn', "shipmentReadYn", 'endReadYn', 'taxReadYn', 'accountsReceivableReadYn']}>
                            <li className={`${getActiveMenuClass("order")} ${openMenus["order"] ? "open" : ""}`}>
                                <a onClick={() => toggleMenu("order")}>
                                    <div className="menu menu2">{t('menu-order')}</div>
                                    <div className="btn_arrow"></div>
                                </a>
                                {openMenus["order"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                    <ul>
                                        <AuthorityChecker authorityNames={['orderReadYn']}>
                                            <li className={getActiveClass("/order/orderRequest")}>
                                                <a onClick={() => goToNavigation("order/orderRequest/list", "", false)}>
                                                    {t('menu-second-order-request')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['shipmentReadYn']}>
                                            <li className={getActiveClass("/order/orders")}>
                                                <a onClick={() => goToNavigation("order/orders/list", "", false)}>
                                                    {t('menu-second-orders')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['endReadYn']}>
                                            <li className={getActiveClass("/order/deadline")}>
                                                <a onClick={() => goToNavigation("order/deadline/list", "", false)}>
                                                    {t('menu-second-deadline')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['taxReadYn']}>
                                            <li className={getActiveClass("/order/invoice")}>
                                                <a onClick={() => goToNavigation("order/invoice/list", "", false)}>
                                                    {t('menu-second-tax_invoice')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['accountsReceivableReadYn']}>
                                            <li className={getActiveClass("/order/receivables")}>
                                                <a onClick={() => goToNavigation("order/receivables/list", "", false)}>
                                                    {t('menu-second-receivables')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                    </ul>)}
                            </li>
                        </AuthorityChecker>

                        <AuthorityChecker authorityNames={['productReadYn']}>
                            <li className={getActiveMenuClass("product")}>
                                <a onClick={() => {
                                    goToNavigation("product/list", "", false)
                                }}>
                                    <div className="menu menu3">{t('menu-product')}</div>
                                </a>
                            </li>
                        </AuthorityChecker>

                        <AuthorityChecker
                            authorityNames={['inventoryReadYn', 'inboundReadYn', 'outboundReadYn', 'adjustmentReadYn', 'detailsReadYn', 'analysisReadYn', 'barcodeReadYn']}>
                            <li className={`${getActiveMenuClass("inventory")} ${openMenus["inventory"] ? "open" : ""}`}>
                                <a onClick={() => toggleMenu("inventory")}>
                                    <div className="menu menu4">{t('menu-inventory')}</div>
                                    <div className="btn_arrow"></div>
                                </a>
                                {openMenus["inventory"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                    <ul>
                                        <AuthorityChecker authorityNames={['inventoryReadYn']}>
                                            <li className={getActiveClass("/inventory/inv")}>
                                                <a onClick={() => goToNavigation("inventory/inv/list", "", false)}>
                                                    {t('menu-second-inventory')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['inboundReadYn']}>
                                            <li className={getActiveClass("/inventory/incoming")}>
                                                <a onClick={() => goToNavigation("inventory/incoming/create", "", false)}>
                                                    {t('menu-second-incoming')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['outboundReadYn']}>
                                            <li className={getActiveClass("/inventory/outgoing")}>
                                                <a onClick={() => goToNavigation("inventory/outgoing/create", "", false)}>
                                                    {t('menu-second-outgoing')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['adjustmentReadYn']}>
                                            <li className={getActiveClass("/inventory/adjustment")}>
                                                <a onClick={() => goToNavigation("inventory/adjustment/create", "", false)}>
                                                    {t('menu-second-adjustment')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['detailsReadYn']}>
                                            <li className={getActiveClass("/inventory/history")}>
                                                <a onClick={() => goToNavigation("inventory/history", "", false)}>
                                                    {t('menu-second-history')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['analysisReadYn']}>
                                            <li className={getActiveClass("/inventory/analyze")}>
                                                <a onClick={() => goToNavigation("inventory/analyze/list", "", false)}>
                                                    {t('menu-second-analyze')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['barcodeReadYn']}>
                                            <li className={getActiveClass("/inventory/barcode")}>
                                                <a onClick={() => goToNavigation("inventory/barcode", "", false)}>
                                                    {t('menu-second-barcode')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                    </ul>)}
                            </li>
                        </AuthorityChecker>

                        <AuthorityChecker
                            authorityNames={['clientReadYn', 'contactReadYn', 'projectReadYn', 'tierReadYn']}>
                            <li className={`${getActiveMenuClass("customer")} ${openMenus["customer"] ? "open" : ""}`}>
                                <a onClick={() => toggleMenu("customer")}>
                                    <div className="menu menu5">{t('menu-customer')}</div>
                                    <div className="btn_arrow"></div>
                                </a>
                                {openMenus["customer"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                    <ul>
                                        <AuthorityChecker authorityNames={['clientReadYn']}>
                                            <li className={getActiveClass("/customer/correspondent")}>
                                                <a onClick={() => goToNavigation("customer/correspondent/list", "", false)}>{t('menu-second-correspondent')}</a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['contactReadYn']}>
                                            <li className={getActiveClass("/customer/contact")}>
                                                <a onClick={() => goToNavigation("customer/contact/list", "", false)}>{t('menu-second-contact')}</a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['projectReadYn']}>
                                            <li className={getActiveClass("/customer/project")}>
                                                <a onClick={() => goToNavigation("customer/project/list", "", false)}>{t('menu-second-project')}</a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['tierReadYn']}>
                                            <li className={getActiveClass("/customer/tier")}>
                                                <a onClick={() => goToNavigation("customer/tier/list", "", false)}>{t('menu-second-tier')}</a>
                                            </li>
                                        </AuthorityChecker>
                                    </ul>)}
                            </li>
                        </AuthorityChecker>

                        <AuthorityChecker authorityNames={['faqReadYn', 'qnaReadYn', 'rmaReadYn', 'boardReadYn']}>
                            <li className={`${getActiveMenuClass("support")} ${openMenus["support"] ? "open" : ""}`}>
                                <a onClick={() => toggleMenu("support")}>
                                    <div className="menu menu6">{t('menu-support')}</div>
                                    <div className="btn_arrow"></div>
                                </a>
                                {openMenus["support"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                    <ul>
                                        <AuthorityChecker authorityNames={['faqReadYn']}>
                                            <li className={getActiveClass("/support/faq")}>
                                                <a onClick={() => goToNavigation("support/faq/list", "", false)}>
                                                    {t('menu-second-faq')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['qnaReadYn']}>
                                            <li className={getActiveClass("/support/qna")}>
                                                <a onClick={() => goToNavigation("support/qna/list", "", false)}>
                                                    {t('menu-second-qna')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['rmaReadYn']}>
                                            <li className={getActiveClass("/support/rma")}>
                                                <a onClick={() => goToNavigation("support/rma/list", "", false)}>
                                                    {t('menu-second-rma')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['boardReadYn']}>
                                            <li className={getActiveClass("/support/board")}>
                                                <a onClick={() => goToNavigation("support/board/list", "", false)}>
                                                    {t('menu-second-board')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                    </ul>)}
                            </li>
                        </AuthorityChecker>

                        <li className={`${getActiveMenuClass("manage")} ${openMenus["manage"] ? "open" : ""}`}>
                            <a onClick={() => toggleMenu("manage")}>
                                <div className="menu menu8">{t('menu-manage')}</div>
                                <div className="btn_arrow"></div>
                            </a>
                            {openMenus["manage"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                <ul>
                                    <AuthorityChecker authorityNames={['accountReadYn']}>
                                        <li className={getActiveClass("/manage/account")}>
                                            <a onClick={() => goToNavigation("manage/account/list", "", false)}>
                                                {t('menu-second-account')}
                                            </a>
                                        </li>
                                    </AuthorityChecker>
                                    <AuthorityChecker authorityNames={['roleReadYn']}>
                                        <li className={getActiveClass("/manage/role")}>
                                            <a onClick={() => goToNavigation("manage/role/list", "", false)}>
                                                {t('menu-second-roles')}
                                            </a>
                                        </li>
                                    </AuthorityChecker>
                                    <AuthorityChecker authorityNames={['itemReadYn']}>
                                        <li className={getActiveClass("/manage/items")}>
                                            <a onClick={() => goToNavigation("manage/items", "", false)}>
                                                {t('menu-second-code')}
                                            </a>
                                        </li>
                                    </AuthorityChecker>
                                    <li className={getActiveClass("/manage/mypage")}>
                                        <a onClick={() => goToNavigation("manage/mypage", "", false)}>
                                            {t('menu-second-mypage')}
                                        </a>
                                    </li>
                                </ul>)}
                        </li>

                    </ul>
                </div>
            </div>
            // 외부(inOutFlag === 1) =======================================
            : <div className="nav-container">
                <div className="nav-top-box">
                    <a className="btn btn-link p-0 logo">
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/logo_private.png"}
                            alt="Logo"
                            onClick={() => goToNavigation('purchase/pcs/list', "", false)}
                        />
                    </a>
                </div>
                <div className="nav-list">
                    <ul>
                        <li className={`${getActiveMenuClass("main")} ${openMenus["main"] ? "open" : ""}`}>
                            <a onClick={() => toggleMenu("main")}>
                                <div className="menu menu1">{t('menu-home')}</div>
                                <div className="btn_arrow"></div>
                            </a>
                            {openMenus["main"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                <ul>
                                    {/*<li className={getActiveClass("/mds/main/dashboard")}>
                                            <a onClick={() => goToNavigation("main/dashboard", "", false)}>
                                                {t('menu-second-dashboard')}
                                            </a>
                                        </li>*/}
                                    <li className={getActiveClass("/main/exchange")}>
                                        <a onClick={() => goToNavigation("main/exchange", "", false)}>
                                            {t('menu-second-exchange')}
                                        </a>
                                    </li>
                                </ul>)}
                        </li>

                        <AuthorityChecker authorityNames={['orderReadYn']}>
                            <li className={`${getActiveMenuClass("purchase")} ${openMenus["purchase"] ? "open" : ""}`}>
                                <a onClick={() => toggleMenu("purchase")}>
                                    <div className="menu menu9">{t('menu-purchase')}</div>
                                    <div className="btn_arrow"></div>
                                </a>
                                {openMenus["purchase"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                    <ul>
                                        <li className={getActiveClass("/purchase/pcs")}>
                                            <a onClick={() => goToNavigation("purchase/pcs/list", "", false)}>
                                                {t('menu-second-purchase')}
                                            </a>
                                        </li>
                                        <li className={getActiveClass("/purchase/delivery")}>
                                            <a onClick={() => goToNavigation("purchase/delivery/list", "", false)}>
                                                {t('menu-second-delivery')}
                                            </a>
                                        </li>
                                        {/* NOTE: 외부 채권 */}
                                        {/*<li className={getActiveClass("/mds/purchase/bond")}>
                                            <a onClick={() => goToNavigation("purchase/bond/list", "", false)}>
                                                {t('menu-second-bond')}
                                            </a>
                                        </li>*/}
                                    </ul>)}
                            </li>
                        </AuthorityChecker>

                        <AuthorityChecker authorityNames={['productReadYn']}>
                            <li className={getActiveMenuClass("product")}>
                                <a onClick={() => {
                                    goToNavigation("product/list", "", false)
                                }}>
                                    <div className="menu menu3">{t('menu-product')}</div>
                                </a>
                            </li>
                        </AuthorityChecker>

                        <AuthorityChecker authorityNames={['faqReadYn', 'qnaReadYn', 'boardReadYn']}>
                            <li className={`${getActiveMenuClass("support")} ${openMenus["support"] ? "open" : ""}`}>
                                <a onClick={() => toggleMenu("support")}>
                                    <div className="menu menu6">{t('menu-support')}</div>
                                    <div className="btn_arrow"></div>
                                </a>
                                {openMenus["support"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                    <ul>
                                        <AuthorityChecker authorityNames={['faqReadYn']}>
                                            <li className={getActiveClass("/support/faq")}>
                                                <a onClick={() => goToNavigation("support/faq/list", "", false)}>
                                                    {t('menu-second-faq')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['qnaReadYn']}>
                                            <li className={getActiveClass("/support/qna")}>
                                                <a onClick={() => goToNavigation("support/qna/list", "", false)}>
                                                    {t('menu-second-qna')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                        <AuthorityChecker authorityNames={['boardReadYn']}>
                                            <li className={getActiveClass("/support/board")}>
                                                <a onClick={() => goToNavigation("support/board/list", "", false)}>
                                                    {t('menu-second-board')}
                                                </a>
                                            </li>
                                        </AuthorityChecker>
                                    </ul>)}
                            </li>
                        </AuthorityChecker>

                        <li className={`${getActiveMenuClass("manage")} ${openMenus["manage"] ? "open" : ""}`}>
                            <a onClick={() => toggleMenu("manage")}>
                                <div className="menu menu8">{t('menu-manage')}</div>
                                <div className="btn_arrow"></div>
                            </a>
                            {openMenus["manage"] && ( // 메뉴가 열렸을 때만 서브 메뉴 렌더링
                                <ul>
                                    {/*<li className={getActiveClass("/mds/manage/account")}>
                                            <a onClick={() => goToNavigation("manage/account/list", "", false)}>
                                                {t('menu-second-account')}
                                            </a>
                                        </li>*/}
                                    <li className={getActiveClass("/manage/company")}>
                                        <a onClick={() => goToNavigation("manage/company", "", false)}>
                                            {t('menu-second-own_company')}
                                        </a>
                                    </li>
                                    <li className={getActiveClass("/manage/mypage")}>
                                        <a onClick={() => goToNavigation("manage/mypage", "", false)}>
                                            {t('menu-second-mypage')}
                                        </a>
                                    </li>
                                </ul>)}
                        </li>

                    </ul>
                </div>
            </div>
        )}
    </>
};
